import { Card, Skeleton } from '@/shared/components';

const AccountCardContentSkeleton = () => {
  return (
    <Card className="flex flex-col gap-[1.2rem] min-w-[30rem] w-[30rem] h-[16rem] p-[2.4rem_3.2rem] shadow-none">
      <div className="flex align-top justify-between h-[4.8rem]">
        <Skeleton variant="medium" className="w-[8.2rem]" />
        <Skeleton
          variant="avatar"
          className="w-[4.8rem] h-[4.8rem] relative top-[-1.2rem] right-[-1.9rem]"
        />
      </div>
      <Skeleton variant="small" className="w-[8.2rem]" />
      <Skeleton variant="medium" className="w-[18rem]" />
    </Card>
  );
};

export { AccountCardContentSkeleton };
